<template>
  <div class="big-container">
    <loading  v-if="isLoading"/>

    <v-snackbar v-model="showResult" :timeout="2000" :color="color" top> {{ result }} </v-snackbar>
    <div class="container">
      <v-form ref="form" v-model="formValid" lazy-validation>
        <span class="tituloPopUp">Atribuir Disciplina ao Professor</span>
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>
        <v-row>
          <v-col v-if="false" cols="12" sm="12" md="6">
            <v-text-field v-model="editedItem.idFuncionario" label="cod"></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-overflow-btn :rules="obrigqtorioRules" v-model="funcionario" :items="professores" :search-input.sync="searchInDB" label="Funcionário" editable item-value="nome" item-text="nome" @change="SelecionaFuncionario()"></v-overflow-btn>
          </v-col>          

          <v-col cols="12" sm="12" md="6">
            <v-combobox :rules="obrigqtorioRules" v-model="editedItem.curso" item-value="idCurso" @change="editedItem.classe=null" item-text="descricao" :items="cursos" chips label="Curso"></v-combobox>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-combobox :rules="obrigqtorioRules" v-model="editedItem.classe" item-value="id" item-text="descricao" :items="classes" chips label="Classe" @change="loadTurmaComb"></v-combobox>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <v-combobox :rules="obrigqtorioRules" id="turma" v-model="editedItem.turma" item-value="pkturma" item-text="turmadescricao" @change="loadDiscpilanComb" @click="loadDiscpilanComb" :items="turmasFiltered" chips label="Turma"></v-combobox>
          </v-col>

          <v-col cols="12" sm="12" md="12">
            <v-combobox :rules="obrigqtorioRules" id="turma" v-model="editedItem.iddisciplina" item-value="iddisciplina" item-text="descricao" :items="disciplinasFiltered" chips label="Disciplina"></v-combobox>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="close">Cancelar</v-btn>
        <v-btn v-if="!replace" color="blue darken-1" :disabled="!(formValid)" text @click="save">Salvar</v-btn>
        <v-btn v-if="replace" color=" darken-1" text @click="save(true)">Substituir O professor</v-btn>
      </v-card-actions>
    </div>
  </div>
</template>
<script>
import Swal from 'sweetalert2'
import axios from '../../../plugins/axios'
const ls = require('local-storage')
import loading from "../../../components/loading.vue";
export default {
  components: {
    loading
  },
  data: () => ({
    overlay: false,
    showResult: false,
    color: '',
    result: '',
    roles: 'func',
    replace: false,
    disciplinas: [],
    professores_novo: [],
    disciplinasFiltered: [],
    professordiscijaexiste: [],
    classes: [{ id: 1,descricao:'10ª'},{ id: 2,descricao:'11ª'},{ id: 3,descricao:'12ª'},{ id: 4,descricao:'13ª'}],
    obrigqtorioRules: [
      value => !!value || 'campo obrigatório.'
    ],
    progresso: false,
    searchInDB: null,
    isLoading: false,
    items: [],
    model: null,
    search: null,
    text: '',
    Funcionario_selected: null,
    funcionario: '',
    flag_curso: '',
    formValid: true,
    turmasAll: [],
    turmasFiltered: [],
    cursos: [],
    notaRules: [
      v => (v >= 0 && v <= 100) || 'valor da sala invalida',
      v => !!v || 'campo obrigatório.',
      v => !isNaN(v) || 'not number ',
      v => v.length <= 2 || 'valor inválido'
    ],
    professores: [],
    profediscinas: [],
    dialog: false,
    headers: [
      {
        text: 'Nome',
        align: 'left',
        sortable: false,
        value: 'nome'
      },
      { text: 'Lecciona', value: 'descricao' },
      { text: 'Turma & Sala', value: 'turma' },
      { text: 'Periodo', value: 'periodo' },
      { text: 'Curso', value: 'curso' },
      { text: 'Ano Lectivo', value: 'anolectivo' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    editedIndex: -1,
    editedItem: {
      classe: null,
      idProfessorDisciTurma: null,
      curso: null,
      idfuncionario: null,
      iddisciplina: null,
      idpessoa: null,
      professor: null,
      turma: null,
      desciplinaDescricao: ''
    },
    defaultItem: {
      classe: null,
      idProfessorDisciTurma: null,
      curso: null,
      idfuncionario: null,
      iddisciplina: null,
      idpessoa: null,
      professor: null,
      turma: null,
      desciplinaDescricao: ''
    }
  }),

  created() {
    this.iniprofessores()
    this.initprofdisc()
    this.initializeCursos()
    this.initializeturmasAll()
    this.initializedisciplinas()
  },

  methods: {
    async iniprofessores(search) {
      let payload;
      this.overlay = true;
      try {
        if (!search) {
          payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + search + '"}'
        }
        this.professores = await axios.get('/professorFindAll/' + payload).then(res => res.data)
      } catch (error) {
        Swal.fire('Erro', 'Ocorreu um erro durante o carregamento da página!', 'error')
      } finally {
        this.overlay = false;
      }
    },

    async initprofdisc(search) {
      let payload
      this.overlay = true;
      try {
        if (!search) {
          payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + search + '"}'
        }

        this.profediscinas = await axios.get('/professordiscFindAll/' + payload).then(res => res.data)
      } catch (error) {
        Swal.fire('Erro', 'Ocorreu um erro durante o carregamento da página!', 'error')
      } finally {
        this.overlay = false;
      }
    },

    async initializeCursos() {
      this.overlay = true;
      try {
        this.cursos = await axios.get('/cursoFindAll').then(res => res.data)
      } catch (error) {
        Swal.fire('Erro', 'Ocorreu um erro durante o carregamento da página!', 'error')
      } finally {
        this.overlay = false;
      }
    },

    async initializeturmasAll() {
      this.overlay = true;
      try {
        this.turmasAll = await axios.get('/turmaFindAll').then(res => res.data)
      } catch (error) {
        Swal.fire('Erro', 'Ocorreu um erro durante o carregamento da página!', 'error')
      } finally {
        this.overlay = false;
      }
    },

    async initializedisciplinas() {
      this.overlay = true;
      try {
        this.disciplinas = await axios.get('/disciplinaFindAll').then(res => res.data)
      } catch (error) {
        Swal.fire('Erro', 'Ocorreu um erro durante o carregamento da página!', 'error')
      } finally {
        this.overlay = false;
      }
    },


    SelecionaFuncionario() {
      this.Funcionario_selected = this.professores.filter(p => p.nome === this.funcionario)
    },

    loadTurmaComb() {
      this.editedItem.turma = null
      this.editedItem.iddisciplina = null
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === this.editedItem.curso.idCurso && t.idAno_Academico == this.editedItem.classe.id)
      this.$nextTick(() => { this.editedItem.turma = undefined })
    },

    loadDiscpilanComb(turma) {
      this.disciplinasFiltered = this.disciplinas.filter(t => t.idCurso === turma.idCurso && t.anoacademico === turma.idAno_Academico)
      this.$nextTick(() => { this.editedItem.iddisciplina = undefined })
    },

    close() {
     this.$router.push('/funcionario/menu')
    },

    save(replace) {
      if(this.$refs.form.validate()) {
        this.professordiscijaexiste = this.profediscinas.filter((p) => p.iddisciplina === this.editedItem.iddisciplina.iddisciplina && p.turma === this.editedItem.turma.turmadescricao)
        if (!this.professordiscijaexiste.length > 0 || this.editedItem.idProfessorDisciTurma > 0 || replace === true) {
          this.saveprof(replace)
        } else {
          this.replace = true
          this.formValid = true
          this.$store.dispatch('textMessage', {
            msg: this.professordiscijaexiste[0].nome + ' é o professor que  lecciona  ' + this.editedItem.iddisciplina.descricao.toUpperCase() + ' na turma  ' + this.editedItem.turma.turmadescricao,
            classMessage: 'msgError',
            timeout: 7000
          })
        }
      } else {
        this.showResult = true;
        this.result = `Preencha os campos vázios!`;
        this.color = "red";
      }
    },

    Actualizar(replace) {
      if (this.professordiscijaexiste.length) {
        let indice = this.profediscinas.indexOf(this.professordiscijaexiste[0])
        this.profediscinas.splice(indice, 1)
      }
    },

    async saveprof(replace) {
      this.progresso = true
      if (this.professordiscijaexiste.length) {
        var params = {
          idProfessorDisciTurma: (this.professordiscijaexiste.length) ? this.professordiscijaexiste[0].idProfessordisciturma : 0,
          idTurma: this.editedItem.turma.idTurma,
          iddisciplina: this.editedItem.iddisciplina.iddisciplina,
          idProfessor: this.Funcionario_selected[0].idProfessor,
          fkTurma: this.editedItem.turma.pkTurma,
          desciplinaDescricao: this.editedItem.iddisciplina.descricao,
          idpessoa: this.Funcionario_selected[0].idPessoa

        }
      } else {
        params = {
          'idProfessorDisciTurma': 0,
          'idTurma': this.editedItem.turma.idTurma,
          'iddisciplina': this.editedItem.iddisciplina.iddisciplina,
          'idProfessor': this.Funcionario_selected[0].idProfessor,
          'fkTurma': this.editedItem.turma.pkTurma,
          'desciplinaDescricao': this.editedItem.iddisciplina.descricao,
          'idpessoa': this.Funcionario_selected[0].idPessoa
        }
      }

      try {
        let msg = await axios.post('/professordisciInsertOrUpdate', params).then(res => res.data)

        // Verificação da mensagem retornada pelo server
        if (msg.length) {
          Swal.fire('Erro', 'Ocorreu um erro durante a atribuição de turma ao professor!', 'error')
        } else {
          Swal.fire('Sucesso', 'Turma atribuida com sucesso', 'success');
          this.$router.push('/professor/listagem')
        }
      } catch (error) {
        Swal.fire('Erro', 'Ocorreu um erro durante a atribuição de turma ao professor!', 'error')
      } finally {
        this.overlay = false;
      }
    }
  }
}
</script>

<style scoped>
.big-container {
  height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tituloPopUp {
  text-align: center;
  display: block;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 15px;
}
.container {
  width: 70%;
  max-width: 500px;
  background-color: #fff;
  border: 0.1px solid #c2c2dd;
  padding: 20px;
  font-size: 12px;
  font-family: sans-serif;
}
</style>
